import type { FeatureRoute } from '../types';
import { TenantDetailPage } from './TenantDetailPage';
import { TenantsPage } from './TenantsPage';

/** Screens of this feature (A2). */
export const routes: FeatureRoute[] = [
  { path: 'tenants', element: <TenantsPage /> },
  { path: 'tenants/:id', element: <TenantDetailPage /> },
];
